// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__4V7Yx","header":"ReportDetails_header__1NClK","title":"ReportDetails_title__3FotO","left":"ReportDetails_left__3Ps3U"};